import React from 'react';
import PartsAndBundleViewIcon from '@mui/icons-material/Dvr';
import EventNoteIcon from '@mui/icons-material/EventNote';

import { TooltipIconButton } from '@paragon/client-tools';

import {
  showImportAssemblyGroupDialog,
  showPartsDialog,
  showSelectScheduleLineGroupDialog,
} from '../../store/actions/popupActions';
import { getActiveStation } from '../../store/selectors/getActiveStation';
import { useAppDispatch, useAppSelector } from '../hooks';
import { ContextToolbarContainer, ContextToolbarTitle } from './contextToolbarComponents';

export function StationContextHeaderToolbar() {
  const dispatch = useAppDispatch();
  const activeStation = useAppSelector(getActiveStation);
  const activeScheduleLineGroupGuid = useAppSelector((state) => state.productionModels.activeScheduleLineGroupGuid);

  if (activeStation == null) return null;

  return (
    <ContextToolbarContainer>
      <ContextToolbarTitle>{activeStation.name}</ContextToolbarTitle>

      {activeStation.followsSchedule ? (
        <TooltipIconButton
          enableInteractive
          title="Select Schedule Line Group"
          onClick={() => void dispatch(showSelectScheduleLineGroupDialog())}
        >
          <EventNoteIcon />
        </TooltipIconButton>
      ) : (
        <TooltipIconButton
          enableInteractive
          title="Import Assembly Group"
          onClick={() => void dispatch(showImportAssemblyGroupDialog())}
        >
          <EventNoteIcon />
        </TooltipIconButton>
      )}

      <TooltipIconButton
        enableInteractive
        title={`Parts${activeStation.followsSchedule ? ' and Bundle' : ''} View`}
        disabled={activeStation.followsSchedule ? activeScheduleLineGroupGuid === null : false}
        onClick={() => void dispatch(showPartsDialog())}
      >
        <PartsAndBundleViewIcon />
      </TooltipIconButton>
    </ContextToolbarContainer>
  );
}
